import Loadable from '../../components/loadable';

const PastGradings = Loadable({
  loader: () => import('../../pages/gradings/past_gradings'),
  type: 'block',
});

angular.module('gym').value('PastGradings', PastGradings);

const PastGradingsFiltersModal = Loadable({
  loader: () => import('react/pages/gradings/past_gradings_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('PastGradingsFiltersModal', PastGradingsFiltersModal);
